// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".business[data-v-3446a220]{margin-top:12px;min-height:564px;margin-bottom:40px}.business .divider[data-v-3446a220]{margin:10px 0 20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
